import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      //componentes formulario de solicitudes, eventual, gimnasia, MIM
      form: {
        title: "Complete the form to coordinate your trip",
        alertMessage: "Please complete the following fields:",
        fields: {
          name: "Name",
          email: "Email",
          phone: "Phone/WhatsApp",
          departureDate: "Departure Date",
          passengers: "Passengers",
          origin: "Place of Origin",
          originPlaceholder: "Country / State / City",
          serviceType: "Type of Service",
          returnDate: "Return Date",
          comments: "Comments",
          chooseOption: "Choose an option",
          welcome: "Welcome",
          numberPassengers: "Number of Passengers",
          placeOrigin: "Place of Origin",
          placeDestination: "Place of Destination",
          namePlaceholder: "Company, Institution, or Name",
          Until: "Until",
          service: "Onboard Service",
          basic: "Basic: Coffee and Beverages",
          intermediate: "Intermediate: Dinner and Breakfast",
          noService: "No Service",
          otherService: "Other Type of Service",
          commentsItinerary: "Comments / Itinerary",
        },
        options: {
          roundTrip: "Round Trip Tickets",
          excursions: "Excursions in Mendoza",
          wineBus: "Wine Bus",
        },
        buttons: { submit: "Submit Request" },
        alerts: {
          missingFields: "Please complete the following fields:",
          blockedH4: "Form disabled",
          blockedP: "The request will be enabled again at the next event.",
         },
        messages: {
          thankYou: "Thank you for providing your information.",
          successContact: "We will contact you by phone to coordinate the requested service.",
          sendingRequest: "Sending your request...",
          returnForm: "Return to the form",
        },
      },

      //componente formulario de satisfaccion
      SatisfactionSurvey: {
        questions: {
          labelStep2: "Punctuality of the Service",
          labelStep3: "Condition and Cleanliness of the Bus",
          labelStep4: "Professionalism of the Driver",
          labelStep5: "Comfort of the Journey",
          labelStep6: "Overall Service Quality",
        },
        options: {
          step1: "Very Satisfied",
          step2: "Satisfied",
          step3: "Neutral",
          step4: "Dissatisfied",
          step5: "Very Dissatisfied",
        },
        header1: "Thank you for completing the survey.",
        header2: "Service Satisfaction",
        formGroup: {
          nombre: "Full Name",
          email: "Email:",
          telefono: "Phone/WhatsApp",
          fechaServicio: "Service Date",
          origenDestino: "Origin and Destination of the Trip",
          label7: "Was there any aspect of the service you would like to improve?",
          placeholder7: "Write your comments here...",
          label8: "Would you recommend our service to others?",
          puntualidad: "Your choice helps us improve and provide you with better service.",
          limpiezaBus: "Your choice helps us improve and provide you with better service.",
          profesionalismo: "Your choice helps us improve and provide you with better service.",
          comodidad: "Your choice helps us improve and provide you with better service.",
          calidadGeneral: "Your choice helps us improve and provide you with better service.",
          recomendar: "Your choice helps us improve and provide you with better service.",
          optionStep8: {
            option1: "Select an option",
            option2: "Yes",
            option3: "No",
          },
          label9: "Ready! Submit the information",
        },
        button: {
          siguiente: "Next",
          enviar: "Submit",
        },
        alertMessage: "Please complete this section.",
      },

    },
  },
  es: {
    translation: {
      //componentes formulario de solicitudes, eventual, gimnasia, MIM
      form: {
        title: "Completá los datos para coordinar tu viaje",
        alertMessage: "Por favor, completa los siguientes campos:",
        fields: {
          name: "Nombre",
          email: "Correo",
          phone: "Teléfono/WhatsApp",
          departureDate: "Fecha de Salida",
          passengers: "Pasajeros",
          origin: "Lugar de origen",
          originPlaceholder: "País / Provincia / Ciudad",
          serviceType: "Tipo de Servicio",
          returnDate: "Fecha de Regreso",
          comments: "Comentarios",
          chooseOption: "Elija una opción",
          welcome: "Bienvenido",
          numberPassengers: "Cantidad de Pasajeros",
          placeOrigin: "Lugar de Origen",
          placeDestination: "Lugar de Destino",
          namePlaceholder: "Empresa, inst. o nombre",
          Until: "Hasta",
          service: "Servicio a Bordo",
          basic: "Básico: Cafetería y bebidas",
          intermediate: "Intermedio: Cena y desayuno",
          noService: "Sin servicio",
          otherService: "Otro Tipo de Servicio",
          commentsItinerary: "Comentarios / Itinerario",
        },
        options: {
          roundTrip: "Pasajes Ida y Vuelta",
          excursions: "Excursiones en Mendoza",
          wineBus: "Bus Vitivinícola",
        },
        buttons: { submit: "Enviar Solicitud" },
        alerts: { 
          missingFields: "Por favor, completa los siguientes campos:",
          blockedH4: "Formulario deshabilitado",
          blockedP: "La solicitud estará habilitada nuevamente en el próximo evento.",
        },
        messages: {
          thankYou: "Gracias por proporcionar tus datos.",
          successContact: "Nos pondremos en contacto contigo por teléfono para coordinar el servicio que solicitaste.",
          sendingRequest: "Enviando tu solicitud...",
          returnForm: "Regresar al formulario",
        },
      },

      //componente formulario de satisfaccion
      SatisfactionSurvey: {
        questions: {
          labelStep2: "Puntualidad del Servicio",
          labelStep3: "Estado y Limpieza del Bus",
          labelStep4: "Profesionalismo del Chofer",
          labelStep5: "Comodidad del Viaje",
          labelStep6: "Calidad del Servicio en General",
        },
        options: {
          step1: "Muy Satisfecho",
          step2: "Satisfecho",
          step3: "Neutral",
          step4: "Insatisfecho",
          step5: "Muy Insatisfecho",
        },
        header1: "Gracias por completar la encuesta.",
        header2: "Satisfacción del Servicio",
        formGroup: {
          nombre: "Nombre Completo",
          email: "Email",
          telefono: "Teléfono/WhatsApp",
          fechaServicio: "Fecha del Servicio",
          origenDestino: "Origen y Destino del Viaje",
          label7: "¿Hubo algún aspecto del servicio que le gustaría mejorar?",
          placeholder7: "Escribe tus comentarios aquí...",
          label8: "¿Recomendaría nuestro servicio a otros?",
          puntualidad: "Tu elección nos ayuda a mejorar y brindarte un mejor servicio.",
          limpiezaBus: "Tu elección nos ayuda a mejorar y brindarte un mejor servicio.",
          profesionalismo: "Tu elección nos ayuda a mejorar y brindarte un mejor servicio.",
          comodidad: "Tu elección nos ayuda a mejorar y brindarte un mejor servicio.",
          calidadGeneral: "Tu elección nos ayuda a mejorar y brindarte un mejor servicio.",
          recomendar: "Tu elección nos ayuda a mejorar y brindarte un mejor servicio.",
          optionStep8: {
            option1: "Seleccione una opción",
            option2: "Sí",
            option3: "No",
          },
          label9: "¡Listo! envía la información",
        },
        button: {
          siguiente: "Siguiente",
          enviar: "Enviar",
        },
        alertMessage: "Por favor, completa esta sección.",
      },

    },
  },
  pt: {
    translation: {
      form: {
        //componentes formulario de solicitudes, eventual, gimnasia, MIM
        title: "Preencha os dados para coordenar sua viagem",
        alertMessage: "Por favor, preencha os seguintes campos:",
        fields: {
          name: "Nome",
          email: "E-mail",
          phone: "Telefone/WhatsApp",
          departureDate: "Data de Saída",
          passengers: "Passageiros",
          origin: "Local de Origem",
          originPlaceholder: "País / Estado / Cidade",
          serviceType: "Tipo de Serviço",
          returnDate: "Data de Retorno",
          comments: "Comentários",
          chooseOption: "Escolha uma opção",
          welcome: "Bem-vindo / Bem-vinda",
          numberPassengers: "Quantidade de Passageiros",
          placeOrigin: "Local de Origem",
          placeDestination: "Local de Destino",
          namePlaceholder: "Empresa, Inst. ou Nome",
          Until: "Até",
          service: "Serviço a Bordo",
          basic: "Básico: Cafeteria e Bebidas",
          intermediate: "Intermediário: Jantar e Café da Manhã",
          noService: "Sem Serviço",
          otherService: "Outro Tipo de Serviço",
          commentsItinerary: "Comentários / Itinerário",
        },
        options: {
          roundTrip: "Passagens Ida e Volta",
          excursions: "Excursões em Mendoza",
          wineBus: "Ônibus do Vinho",
        },
        buttons: { submit: "Enviar Solicitação" },
        alerts: { 
          missingFields: "Por favor, preencha os seguintes campos:",
          blockedH4: "Formulário desativado",
          blockedP: "A solicitação estará disponível novamente no próximo evento.",
        },
        messages: {
          thankYou: "Obrigado por fornecer suas informações.",
          successContact: "Entraremos em contato com você por telefone para coordenar o serviço solicitado.",
          sendingRequest: "Enviando sua solicitação...",
          returnForm: "Voltar ao formulário",
        },
      },

      //componente formulario de satisfaccion
      SatisfactionSurvey: {
        questions: {
          labelStep2: "Pontualidade do Serviço",
          labelStep3: "Estado e Limpeza do Ônibus",
          labelStep4: "Profissionalismo do Motorista",
          labelStep5: "Conforto da Viagem",
          labelStep6: "Qualidade Geral do Serviço",
        },
        options: {
          step1: "Muito Satisfeito",
          step2: "Satisfeito",
          step3: "Neutro",
          step4: "Insatisfeito",
          step5: "Muito Insatisfeito",
        },
        header1: "Obrigado por completar a pesquisa.",
        header2: "Satisfação do Serviço",
        formGroup: {
          nombre: "Nome Completo",
          email: "E-mail",
          telefono: "Telefone/WhatsApp",
          fechaServicio: "Data do Serviço",
          origenDestino: "Origem e Destino da Viagem",
          label7: "Houve algum aspecto do serviço que você gostaria de melhorar?",
          placeholder7: "Escreva seus comentários aqui...",
          label8: "Você recomendaria nosso serviço a outros?",
          puntualidad: "Sua escolha nos ajuda a melhorar e oferecer um serviço melhor.",
          limpiezaBus: "Sua escolha nos ajuda a melhorar e oferecer um serviço melhor.",
          profesionalismo: "Sua escolha nos ajuda a melhorar e oferecer um serviço melhor.",
          comodidad: "Sua escolha nos ajuda a melhorar e oferecer um serviço melhor.",
          calidadGeneral: "Sua escolha nos ajuda a melhorar e oferecer um serviço melhor.",
          recomendar: "Sua escolha nos ajuda a melhorar e oferecer um serviço melhor.",
          optionStep8: {
            option1: "Selecione uma opção",
            option2: "Sim",
            option3: "Não",
          },
          label9: "Pronto! Envie as informações",
        },
        button: {
          siguiente: "Próximo",
          enviar: "Enviar",
        },
        alertMessage: "Por favor, preencha esta seção.",
      },

    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "es", // Idioma predeterminado
  fallbackLng: "es", // Idioma en caso de error
  interpolation: { escapeValue: false }, // No escapamos valores HTML
});

export default i18n;